<template>
  <div class="commonSelect">
    <!-- h5Picker -->
    <van-field
      v-if="$isFlag"
      readonly
      clickable
      name="picker"
      style="border-radius:0"
      :label="selectionInfo.selectName"
      :value="time"
      placeholder="点击选择"
      @click="showDate = true"
    />
    <!-- web下拉 -->
    <div v-else class="selectWebClass">
      <p>{{ selectionInfo.selectName }}</p>
      <el-date-picker
        v-model="time"
        :type="webDateType"
        placeholder="请选择"
        value-format="yyyy-MM"
        placement="bottom-start"
        :picker-options="pickerOptions"
        @change="handleChange"
      />
    </div>
    <!-- h5 popup -->
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        :type="h5DateType"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showDate = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'CommonSelect',
  props: {
    selectionInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    h5DateType: {
      type: String,
      default: 'year-month'
    },
    webDateType: {
      type: String,
      default: 'month'
    },
    pickerOptions: {
      type: Object,
      default: () => {
        return {}
      }
    },
    minDate: {
      type: Date,
      default: () => {
        return new Date(2000, 0, 1)
      }
    }
  },
  data() {
    return {
      time: '',
      showDate: false,
      // minDate: new Date(2000, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date()
    }
  },
  created() {},
  mounted() {
  },
  methods: {
    handleChange(e) {
      console.log(e)
      this.$emit('emitTimeVal', e)
    },
    onConfirm(val) {
      this.time = moment(val).format('YYYY-MM')
      this.showDate = false
      this.$emit('emitTimeVal', moment(val).format('YYYY-MM'))
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';
</style>

